export const isLegacyBrowser = (browserName) => {
  return browserName === 'Internet Explorer';
};
